import * as React from "react";
export function SvgSpacesDataStatus(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg width={15} height={15} {...props}>
      <circle cx={7.5} cy={7.5} r={6.5} fill="#1a699e" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#fff"
        d="M7 4h1v5H7zM7 10h1v1H7z"
      />
    </svg>
  );
}
